import useInput from "../Hooks/use-input";
import classes from "./Login.module.css";
import { Fragment, useState } from "react";
import Card from "../UI/Card";
import authContext from "../../store/auth-context";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { getApiChara } from "../../util/getApi";
import Loader from "../UI/Loader";
import { FaEye, FaEyeSlash, FaSignInAlt, FaEraser } from "react-icons/fa";
import { toast } from "react-toastify";
import logo from "../../assests/drtechbuddy.png";

// Function to fetch hospital data (dummy implementation
const Login = () => {
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // New state for loader
  const navigate = useNavigate();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const ctx = useContext(authContext);
  const {
    value: enteredUName,
    isValid: enteredUNameIsValid,
    hasError: userUNameHasError,
    inputValueHandler: uNameInputChangeHandler,
    inputBlurHandler: uNameInputBlurHandler,
    reset: resetUNameInput,
  } = useInput("blankval");
  const {
    value: enteredPassword,
    isValid: enteredPasswordIsValid,
    hasError: PasswordInputHaError,
    inputValueHandler: passwordInputChangeHandler,
    inputBlurHandler: passwordInputBlurHandler,
    reset: resetPasswordInput,
  } = useInput("blankval");

  const userNameIsValidClasses = userUNameHasError
    ? "form-control invalid"
    : "form-control";
  const passwordIsValidClasses = PasswordInputHaError
    ? "form-control invalid"
    : "form-control";
  const onLoginFormSubmitHandler = async (event) => {
    event.preventDefault();

    // Check if any other validation errors exist
    if (!enteredUNameIsValid || !enteredPasswordIsValid) {
      return;
    }
    const loginData = {
      userName: enteredUName,
      password: enteredPassword,
    };

    setIsLoading(true);

    const apiChar = getApiChara();
    const fetchApi = `${apiChar}/auth/login`;
    try {
      const response = await fetch(fetchApi, {
        method: "post",
        body: JSON.stringify(loginData),
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response.status >= 400 && response.status < 500) {
        setError(true);
        toast.error("Invalid credentials..");
        return;
      }
      if (response.status >= 500 && response.status < 600) {
        navigate("/access-denied?errorCode=500&errorMessage=Server%20is%20offline&errorDescription=check%20your%20internet%20connection%20or");
      }
      if (!response.ok) {
        toast.error("Network response was not ok");
      }
      const data = await response.json();
      const token = data?.token;
      const role = data?.role;
      const userName = data?.userName;
      const tenantOrClientId = data?.tenantOrClientId;
      const userId = data?.userId;
      if (token !== null) {
        ctx.onLogin(token, userName, userId, role, tenantOrClientId);
        resetUNameInput();
        resetPasswordInput();
        navigate("dashboard");
      } else {
        ctx.onLogin(false);
        navigate("/");
        toast.error("Invalid credential..");
      }
    } catch (error) {
      toast.error("Network response was not ok");
    } finally {
      setIsLoading(false); // Hide loader after fetching data
    }
  };

  const resetInputs = () => {
    resetUNameInput();
    resetPasswordInput();
  };
  const togglePasswordVisibility = () => {
    setPasswordVisible((prevState) => !prevState);
  };
  return (
    <Fragment>
      {/* Loader component */}
      {isLoading && <Loader />}

      {/* Wrapper around login form */}
      <div className={classes.wrapper}>
        <div className={classes.loginCard}>
          <div className={classes.inner}>
            <div className={classes.logoContainer}>
              <img src={logo} alt="Dr. Tech Buddy Logo" className={classes.logo} />
            </div>
            <h2 className={classes.title}>Login Here</h2>
            <form onSubmit={onLoginFormSubmitHandler}>
              <div className={classes.inputGroup}>
                <label className={classes.label} htmlFor="uname">User Name</label>
                <input
                  type="text"
                  className={`${classes.formControl} ${userUNameHasError ? classes.invalid : ""}`}
                  value={enteredUName}
                  onChange={uNameInputChangeHandler}
                  onBlur={uNameInputBlurHandler}
                  id="uname"
                  autoComplete="username"
                  placeholder="Enter your username"
                />
                {userUNameHasError && (
                  <p className={classes.errorText}>Please enter a valid username</p>
                )}
              </div>

              <div className={classes.inputGroup}>
                <label className={classes.label} htmlFor="pwd">Password</label>
                <div className={classes.passwordWrapper}>
                  <input
                    type={passwordVisible ? "text" : "password"}
                    className={`${classes.formControl} ${PasswordInputHaError ? classes.invalid : ""}`}
                    value={enteredPassword}
                    onChange={passwordInputChangeHandler}
                    onBlur={passwordInputBlurHandler}
                    id="pwd"
                    autoComplete="current-password"
                    placeholder="Enter your password"
                  />
                  <span
                    onClick={togglePasswordVisibility}
                    className={classes.passwordToggle}
                    title={passwordVisible ? "Hide Password" : "Show Password"}
                  >
                    {passwordVisible ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
                {PasswordInputHaError && (
                  <p className={classes.errorText}>Please enter your password</p>
                )}
              </div>

              <div className={classes.actions}>
                <button type="submit" className={classes.submitBtn}>
                  <FaSignInAlt />
                  {isLoading ? "Signing In..." : "Log In"}
                </button>
                <button type="button" onClick={resetInputs} className={classes.clearBtn}>
                  <FaEraser />
                  Clear
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Login;
